import React, { useState } from "react";
import { Spinner, Button } from "react-bootstrap";

import NewsLetterModal from "./NewsLetterModal";
export default function NewsletterForm({ status, message, onValidated }) {
  const [error, setError] = useState(null);
  const [email, setEmail] = useState(null);

  /**
   * Handle form submit.
   *
   * @return {{value}|*|boolean|null}
   */
  const handleFormSubmit = () => {
    setError(null);

    if (!email) {
      setError("Please enter a valid email address");
      setTimeout(() => {
        setError(null);
      }, 4000);
      return null;
    }

    const isFormValidated = onValidated({ EMAIL: email });

    // On success return true
    return email && email.indexOf("@") > -1 && isFormValidated;
  };

  /**
   * Handle Input Key Event.
   *
   * @param event
   */
  const handleInputKeyEvent = (event) => {
    setError(null);
    // Number 13 is the "Enter" key on the keyboard
    if (event.keyCode === 13) {
      // Cancel the default action, if needed
      event.preventDefault();
      // Trigger the button element with a click
      handleFormSubmit();
    }
  };

  /**
   * Extract message from string.
   *
   * @param {String} message
   * @return {null|*}
   */
  const getMessage = (message) => {
    if (!message) {
      return null;
    }
    const result = message?.split("-") ?? null;
    if ("0" !== result?.[0]?.trim()) {
      return message;
    }
    const formattedMessage = result?.[1]?.trim() ?? null;
    return formattedMessage ? formattedMessage : null;
  };

  return (
    <>
      <div className="input-group px-0 ">
        <input
          onChange={(event) => setEmail(event?.target?.value ?? "")}
          type="email"
          placeholder="Your email"
          onKeyUp={(event) => handleInputKeyEvent(event)}
          className="form-control input-brand"
          aria-label="Your email address"
          aria-describedby="basic-addon2"
        />
        <Button
          onClick={handleFormSubmit}
          variant="light"
          className="fw-bolder  border"
          type="button"
          id="button-addon2"
        >
          Subscribe
        </Button>
      </div>
      <div className="pt-2">
        {"nothing" === status ? "" : null}
        {"sending" === status ? (
          <Spinner animation="border" variant="warning" className="" />
        ) : null}
        {"error" === status || error ? (
          <div
            className="text-danger pt-2"
            dangerouslySetInnerHTML={{ __html: error || getMessage(message) }}
          />
        ) : null}
        {"success" === status && "error" !== status && !error && (
          <div
            className="text-success fw-bold pt-2"
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}
      </div>

      <NewsLetterModal opened={"success" === status ? true : false} />
    </>
  );
}
